import { useSyncExternalStore } from "react";
import { isSidebandVisible, subscribeSidebandVisible } from "../lib/sideband-visibility";

/** Feedback en direct pendant l'appel visible (interrupteur `SIDEBAND_ENABLED`, `sideband-visibility.ts`). */
export function useSidebandVisible(): boolean {
  return useSyncExternalStore(subscribeSidebandVisible, isSidebandVisible, isSidebandVisible);
}
